import { Locale } from "../../../api/services/common/models";
import { LANGUAGE_CODE } from "../../../helpers/constants";
import {
  convertLocalizeObjToFormValue,
  getFieldValue,
  isEmpty,
  isNotEmpty,
} from "../../../helpers/utils";
import { TemplateActivityData } from "./Models";

const setLocalizedTopicForActivity = (
  localizedTopics: Locale[],
  userSelectedLanguage: string,
) => {
  const userSelectedLanguageTopic = localizedTopics.find(
    (item: Locale) => item.localeKey === userSelectedLanguage,
  );
  const englishLanguageTopic = localizedTopics.find(
    (item: Locale) => item.localeKey === LANGUAGE_CODE.EN_US,
  );

  if (isEmpty(userSelectedLanguageTopic) && isNotEmpty(englishLanguageTopic)) {
    localizedTopics.push({
      name: englishLanguageTopic.name,
      localeKey: userSelectedLanguage,
    });
  }
  if (isEmpty(englishLanguageTopic) && isNotEmpty(userSelectedLanguageTopic)) {
    localizedTopics.push({
      name: userSelectedLanguageTopic.name,
      localeKey: LANGUAGE_CODE.EN_US,
    });
  }

  return localizedTopics;
};

export const getLocalizedTopicForActivity = (
  templateActivityData: TemplateActivityData,
  userSelectedLanguage: string,
) => {
  if (
    templateActivityData?.localizedTopics &&
    templateActivityData?.localizedTopics.length > 0
  ) {
    let localizedTopics = setLocalizedTopicForActivity(
      templateActivityData.localizedTopics,
      userSelectedLanguage,
    );

    return convertLocalizeObjToFormValue(localizedTopics);
  } else {
    return {
      [userSelectedLanguage]: getFieldValue(templateActivityData?.topic),
      [LANGUAGE_CODE.EN_US]: getFieldValue(templateActivityData?.topic),
    };
  }
};

export const getLocalizedTopicForViewActivity = (
  templateActivityData: TemplateActivityData,
  userSelectedLanguage: string,
) => {
  let localizedTopics = [];
  if (
    templateActivityData?.localizedTopics &&
    templateActivityData?.localizedTopics.length > 0
  ) {
    localizedTopics = setLocalizedTopicForActivity(
      templateActivityData.localizedTopics,
      userSelectedLanguage,
    );
  } else {
    localizedTopics = [
      {
        name: getFieldValue(templateActivityData?.topic),
        localeKey: userSelectedLanguage,
      },
      {
        name: getFieldValue(templateActivityData?.topic),
        localeKey: LANGUAGE_CODE.EN_US,
      },
    ];
  }
  return localizedTopics;
};

export const getUserPreferredLanguageTopicValue = (
  templateActivityData: TemplateActivityData,
  userSelectedLanguage: string,
) => {
  const localizedTopics = getLocalizedTopicForViewActivity(
    templateActivityData,
    userSelectedLanguage,
  );

  return localizedTopics?.find(
    (item) => item.localeKey === userSelectedLanguage,
  )?.name;
};
